import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ClientBankAccountHelperDataService } from 'src/app/services/client-bank-account-helper-data.service';

@Component({
  selector: 'terra-israel-bank-select-field',
  template: `
    <label for="ddl{{ fieldName }}Field" class="text-input-label">Bank</label>
    <mat-form-field appearance="outline"
      ><mat-select class="lo_sensitive" [formControl]="control" placeholder="Select" id="ddl{{ fieldName }}Field">
        <mat-option *ngFor="let bank of israeliBankAccounts" [value]="bank.code">
          {{ bank.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="control.hasError('required')">Required</mat-error>
    </mat-form-field>
  `
})
export class IsraelBankSelectFieldComponent implements OnInit {
  @Input()
  public control: UntypedFormControl;
  @Input()
  public fieldName: string;

  @Output()
  bankNameChanged = new EventEmitter<string>();

  public israeliBankAccounts: Array<{ name: string; code: string }>;

  constructor(private helperService: ClientBankAccountHelperDataService) {}

  ngOnInit(): void {
    this.israeliBankAccounts = this.helperService.getILBanks();

    this.control.valueChanges.subscribe(selectedBankCode => {
      const selectedBank = this.israeliBankAccounts.find(b => b.code === this.control.value);
      if (selectedBank) {
        this.bankNameChanged.emit(selectedBank.name);
      }
    });
  }
}
